import { Link } from "react-router-dom";
import { useEventContext } from "../../context/EventContext";
import { formatFromDateDetails, formatTime } from "../../exports/functions";
import { Fade } from "react-awesome-reveal";
import { useLoader } from "../../context/LoaderContext";
import { useState } from "react";
import useTab from "../../hooks/useTab";
import DynamicToolTip from "../DynamicToolTip";

const AllEvents = () => {
  const { loading } = useLoader();
  const tab = useTab();
  const { eventData } = useEventContext();
  const [activeTab, setActiveTab] = useState<string>("upcoming");

  const today = new Date();

  const formatEventDate = (fullDate: string) => new Date(fullDate);

  // Format and filter events
  const filteredEvents = eventData
    ?.map((event) => ({
      ...event,
      attributes: {
        ...event.attributes,
        ...formatFromDateDetails(event?.attributes?.From_Date),
        Time: formatTime(event?.attributes?.Time),
      },
    }))
    ?.filter((event) => {
      const eventDate = formatEventDate(event.attributes.From_Full_Date);
      return activeTab === "upcoming" ? eventDate >= today : eventDate < today;
    });

  return (
    <section className="events-page">
      <div className="container">
        <div className="row">
          <div className="quality-work__tab-box tabs-box">
            <ul
              className="tab-buttons clearfix list-unstyled"
              style={{ justifyContent: "center" }}
            >
              <li
                className={`tab-btn ${
                  activeTab === "upcoming" ? "active-btn" : ""
                }`}
                onClick={() => setActiveTab("upcoming")}
                style={{ maxWidth: tab ? "100%" : "380px" }}
              >
                <span>Upcoming</span>
              </li>
              <li
                className={`tab-btn ${
                  activeTab === "past" ? "active-btn" : ""
                }`}
                onClick={() => setActiveTab("past")}
                style={{ maxWidth: tab ? "100%" : "380px" }}
              >
                <span>Past</span>
              </li>
            </ul>
          </div>

          {!loading && filteredEvents.length === 0 ? (
            <div className="col-12 text-center">
              <p>{`No ${
                activeTab.charAt(0).toUpperCase() + activeTab.slice(1)
              } Events`}</p>
            </div>
          ) : (
            filteredEvents?.map((event, index) => (
              <div className="col-xl-3 col-lg-6 col-md-6" key={index}>
                <Fade
                  key={index}
                  cascade
                  damping={0.2}
                  triggerOnce={true}
                  delay={index * 200}
                >
                  <div className="events__single">
                    <div className="events__img">
                      <img
                        src={`${process.env.REACT_APP_strapiUrl}${event?.attributes?.Image?.data?.attributes?.url}`}
                        alt="event-image"
                        style={{
                          objectFit: "cover",
                          height: "225px",
                          // height: "200px",
                        }}
                      />
                      <div className="events__date">
                        <p>
                          {event?.attributes?.From_Date} <br />
                          {event?.attributes?.From_Month}
                        </p>
                      </div>
                    </div>
                    {/* <div className="events__content" style={{padding: '15px'}}> */}
                    <div className="events__content">
                      <h3 className="events__title custom-grid-font-size text-truncate">
                        <Link
                          to="/events/events-details"
                          state={{
                            index: index,
                            activeTab: activeTab,
                          }}
                        >
                          <DynamicToolTip title={event?.attributes?.Event_Name}>
                            {event?.attributes?.Event_Name}
                          </DynamicToolTip>
                        </Link>
                      </h3>
                      <ul className="list-unstyled events__meta">
                        <li className="d-flex align-items-center">
                          <i className="far fa-clock"></i>
                          {
                            <DynamicToolTip title={event?.attributes?.Time}>
                              {event?.attributes?.Time}
                            </DynamicToolTip>
                          }
                        </li>
                        <li className="text-truncate">
                          <i className="fas fa-map-marker-alt"></i>
                          {
                            <DynamicToolTip
                              title={event?.attributes?.Event_Location}
                            >
                              {event?.attributes?.Event_Location}
                            </DynamicToolTip>
                          }
                        </li>
                      </ul>
                    </div>
                  </div>
                </Fade>
              </div>
            ))
          )}
        </div>
      </div>
    </section>
  );
};

export default AllEvents;
